export default __webpack_public_path__ + "static/media/1999.07ed955b.png";